import React from 'react'
import styles from './Main.module.scss'
import { useTranslation } from 'react-i18next'
import SectionTitle from '../../../../components/SectionTitle/SectionTitle'
import empty from '../../../../img/emptyFinances.svg';

const Main = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.main}>
      <SectionTitle text={t('Shop')} />
      <div className={styles.main__empty}>
        <img src={empty} alt="empty" />
        <h2>{t('Currently there are no products in the store.')}</h2>
      </div>
    </div>
  )
}

export default Main